export { mapCompetitionGrid, getRankingLabel } from './mapCompetitionGrid';
